'use client'
import { getFirestore, Firestore, connectFirestoreEmulator } from 'firebase/firestore';
import firebase_app from '@/app/firebase/config';
// import logger from '@/components/logger';

class FirestoreConnection {
    private static instance: Firestore;

    private constructor() {}

    public static getInstance(): Firestore {
        if (!FirestoreConnection.instance) {
            FirestoreConnection.instance = getFirestore(firebase_app);
            // logger.info('Firestore instance created')
            // Connect to emulator if in dev mode
            if (process.env.NEXT_PUBLIC_DEV_MODE === 'true') {
                connectFirestoreEmulator(FirestoreConnection.instance, 'localhost', 8080);
            }
        }
        return FirestoreConnection.instance;
    }
}

export const getFirestoreInstance = () => FirestoreConnection.getInstance(); 